import styles from './MeritoDateField.module.scss';
import { RiCalendar2Line as CalendarIcon } from 'react-icons/ri';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import DatePicker from "react-datepicker";
import dayjs, { Dayjs } from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateField } from '@mui/x-date-pickers/DateField';

import { createTheme, ThemeProvider } from '@mui/material/styles';
import { TextField } from '@mui/material';

// Create a custom theme to override the MUI styles
const theme = createTheme({
    components: {
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& .MuiInputBase-root-MuiInput-root::after': {
                        borderBottom: 'none', // This targets the underline after effect specifically
                    },
                },
            },
        },
    },
});

// The field hands back a dayjs date (null when empty), wrapped like an input
// event so final-form's input.onChange can take it directly.
type DateFieldChangeEvent = { target: { value: Dayjs | null } };

type Props = {
    label?: string,
    name: string,
    onChange: (event: DateFieldChangeEvent) => void,
    error: any,
    placeholder?: string,
    // anything dayjs() can read: a dayjs date, or a date string
    value: Dayjs | string | null;
    touched: boolean;
    showError?: boolean;
    showBorder?: boolean;
    onBlur?: (e: any) => void;
    format?: 'MM/YYYY' | 'DD/MM/YYYY';
    size?: 'md' | 'md2';
    showIcon?: boolean;
    onFocus?: (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement, Element>) => void;
    focussed?: boolean;
    ignoreTouched?: boolean;
    minDate?: Dayjs;
    maxDate?: Dayjs;
}

const dateFieldFontStyle = {
    "md": {
        fontFamily: "Work Sans",
        fontSize: "0.6875rem",
        fontStyle: "normal",
        fontWeight: "500",
        lineHeight: "0.875rem",
        letterSpacing: "0.00688rem"
    },
    "md2": {
        fontFamily: "Work Sans",
        fontSize: "0.875rem",
        fontStyle: "normal",
        fontWeight: "500",
        lineHeight: "1.125rem", /* 128.571% */
        letterSpacing: "0.00875rem",
    }
}


const MeritoDateField = ({ label, name, size = "md", onChange, error, placeholder, value, showError = true, touched, onBlur, showBorder = false, format = 'MM/YYYY', showIcon = true, onFocus = () => { }, ignoreTouched = false, minDate = dayjs().subtract(20, 'year'), maxDate = dayjs().add(20, 'year'), ...restProps }: Props) => {


    return (
        <div className={`${styles.fieldContainer} ${styles[size]}`}>
            {label && <div className={`${styles.label}`}>{label}</div>}
            <div className={`${styles.inputBox}   ${error && (touched || ignoreTouched) && (showError || showBorder) ? styles.invalid : ''}`}>
                {showIcon ? <div className={styles.iconContainer}>
                    <CalendarIcon />
                </div> : null}
                <div className={styles.dateFieldContainer}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DateField
                            name={name}
                            formatDensity='spacious'
                            variant="standard"
                            format={format}
                            InputProps={{
                                disableUnderline: true,
                            }}
                            inputProps={{
                                onBlur: onBlur,
                                style: {
                                    input: {
                                        '&::placeholder': {
                                            color: "#aaaaaa"
                                        }
                                    }
                                } as any,
                                onFocusCapture: (e) => onFocus(e),
                                ...restProps
                            }}
                            minDate={minDate}
                            maxDate={maxDate}
                            value={value ? dayjs(value) : null}
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '0',
                                    border: 'none',
                                    outline: 'none'

                                },
                                '& .MuiInputBase-root': {
                                    ...dateFieldFontStyle[size]
                                },
                                '& .MuiOutlinedInput-input': {
                                    border: 'none',
                                    outline: 'none',


                                }
                            }}
                            shouldRespectLeadingZeros={true}
                            onChange={(value, context) => {
                                // console.log('value', value['$d'], 'context', context)
                                // onChange({ target: { value: dayjs(value['$d']).format('MM/YYYY') } } as any);
                                onChange({ target: { value } })
                            }}
                        />
                    </LocalizationProvider>
                </div>
            </div>
            {error && touched && showError ? <span className={styles.errorMessage}>{error}</span> : null}
        </div>
    )
}

export default MeritoDateField;